var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M10.252 3.088c.762-1.372 2.734-1.372 3.496 0l8.3 14.94C22.79 19.363 21.827 21 20.302 21H3.7c-1.525 0-2.49-1.638-1.749-2.971z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }